import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { IPublicClientApplication } from "@azure/msal-browser";

import { faLeftToBracket, faRotate, faWarning } from "@fortawesome/pro-regular-svg-icons";

import { fallbackTranslationKeys } from "../../../../models/app-fallabck-translation-keys";
import { ActionButton } from "../../../Shared/Buttons";
import { Icon } from "../../../Shared/Icon/Icon";

import "./ErrorPageWithActionsPage.scss";

interface IErrorPageWithActionsPageProps {
  pca: IPublicClientApplication;
  titleKey: string;
  descriptionKey: string;
}

export const ErrorPageWithActionsPage: FunctionComponent<IErrorPageWithActionsPageProps> = (
  props: IErrorPageWithActionsPageProps,
) => {
  const { t } = useTranslation();

  const logout = () => {
    props.pca.logout();
  };

  const reloadPage = () => {
    window.location.reload();
  };

  return (
    <div className="page-error-page-with-actions">
      <h1 className="header">
        <Icon icon={faWarning} />
        {t(props.titleKey)}
      </h1>

      <p className="description">{t(props.descriptionKey)}</p>

      <div className="buttons">
        <ActionButton
          id="logout-button"
          onClick={logout}
          label={t(fallbackTranslationKeys.actions.logout)}
          icon={faLeftToBracket}
          showBackground
        />

        <ActionButton
          id="reload-page-button"
          onClick={reloadPage}
          label={t(fallbackTranslationKeys.actions.reloadPage)}
          icon={faRotate}
          showBackground
        />
      </div>
    </div>
  );
};
